/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component } from '@angular/core';

/**
 * @export
 * @class LmsLocoComponent
 */
@Component({
    selector: 'lms-loco',
    templateUrl: './loco.component.html',
    styleUrls: ['./loco.component.scss']
})

export class LmsLocoComponent {

    /**
     * Creates an instance of LmsLocoComponent.
     *
     * @memberOf LmsLocoComponent
     */
    constructor() {

    }
}
